import { formatCurrency } from 'utils/formatters'

import { ICurrency } from 'store/fetchers/currencies'

import { ICoinPageCurrency } from 'config/coin-pages-list'

import { FC } from 'react'

import styles from './styles.module.scss'
import twitter from './icons/twitter.svg'
import telegram from './icons/telegram.svg'
import { useTranslation } from 'utils/use-translation'

export const NotSupportedAlert: FC<{
  currency: ICurrency
  pageCurrency: ICoinPageCurrency
}> = ({ currency, pageCurrency }) => {
  const { t } = useTranslation() 
  const formattedCurrency =
    (currency && formatCurrency(currency)) ||
    `${pageCurrency.code?.toUpperCase()} [${pageCurrency.network?.toUpperCase()}]`
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <span>
          {formattedCurrency} loans are <br />{t('service_unavailable')}<span className={styles.alertCheckSpan}>{t('check_for_updates')}</span>
        </span>
        <div className={styles.alertCheckIcons}>
          <a href="https://twitter.com/CoinRabbitLoans">
            <img src={twitter} alt="twitter" />
          </a>{' '}
          or
          <a href="https://t.me/+vKoWSNIXLbZmZTQy">
            <img src={telegram} alt="telegram" />
          </a>
        </div>
      </div>
    </div>
  )
}
